// extracted by mini-css-extract-plugin
export default {"selectCell":"TableSelectCell-selectCell-ip5ko TableRowCell-cell-giPrj","input":"TableSelectCell-input-YHSWy CheckInput-input-VAM1T"};